import { render, staticRenderFns } from "./OldLogoOrPlaceholder.vue?vue&type=template&id=352dc788&lang=pug"
import script from "./OldLogoOrPlaceholder.vue?vue&type=script&lang=js"
export * from "./OldLogoOrPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./OldLogoOrPlaceholder.vue?vue&type=style&index=0&id=352dc788&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports